/* eslint-disable @typescript-eslint/no-explicit-any */
import L from "leaflet";

interface LayerUnwiredOptions extends L.TileLayerOptions {
  subdomains?: string;
  scheme?: "streets" | "satellite";
  format?: string;
  attributions?: string[];
  tileServer?: string;
  path?: string;
  tileResolution?: string;
}

// STIC-15578: tiles are always fetched through the backend map proxy, which injects the
// LocationIQ / Mapbox keys server-side so they are never exposed to the browser.
const LayerUnwiredClass = (L.TileLayer as any).extend({
  options: {
    subdomains: "abc",
    minZoom: 2,
    maxNativeZoom: 20,
    maxZoom: 22,
    scheme: "streets",
    format: "png",
    attributions: [], //depends on map layer,
    tileServer: "/map-proxy/streets/{s}",
    path: "/v3/{scheme}/r/{z}/{x}/{y}{tileResolution}.{format}",
  } as LayerUnwiredOptions,

  initialize: function initialize(options?: LayerUnwiredOptions) {
    options = L.setOptions(this, options) as LayerUnwiredOptions;

    // If it's not Retina, don't add anything here, it'll be 256px by default
    options.tileResolution = "";

    if (options.scheme === "streets") {
      options.attributions = [
        '&copy; <a href="https://locationiq.com/?ref=maps" target="_blank">LocationIQ Maps</a>',
        '<a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> Contributors',
      ];
      options.scheme = "streets";
      options.tileServer = "/map-proxy/streets/{s}";
    } else if (options.scheme === "satellite") {
      options.attributions = [
        'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      ];
      (options as any).scheme = "mapbox.satellite";
      options.tileServer = "/map-proxy/satellite/{s}";
      options.path = "/v4/{scheme}/{z}/{x}/{y}{tileResolution}.{format}";
    }

    //If it's Retina, we need to serve 512px tiles
    if (L.Browser.retina) {
      options.tileResolution = "@2x";
    }

    // STIC-5041: needs to depend on options to allow proxying !!!
    const tileUrl = (options.tileServer || "") + (options.path || "");

    (L.TileLayer.prototype as any).initialize.call(this, tileUrl, options);
  },

  onAdd: function onAdd(map: L.Map) {
    (L.TileLayer.prototype as any).onAdd.call(this, map);

    if (!this._attributionBBoxes && this.options.attributions?.length) {
      this._findCopyrightBBox(this.options);
    }
  },

  onRemove: function onRemove(map: L.Map) {
    (L.TileLayer.prototype as any).onRemove.call(this, map);

    if (this._attributionText && this._map?.attributionControl) {
      this._map.attributionControl.removeAttribution(this._attributionText);
    }

    this._map.off("moveend zoomend resetview", this._findCopyrightBBox, this);
  },

  _findCopyrightBBox: function _findCopyrightBBox(options: LayerUnwiredOptions) {
    if (!this._map?.attributionControl || !options.attributions?.length) return;

    const attributionText = options.attributions.join(", ");
    this._map.attributionControl.addAttribution(
      (this._attributionText = attributionText)
    );
  },
});

(L.TileLayer as any).Unwired = LayerUnwiredClass;
(L.tileLayer as any).Unwired = function (opts?: LayerUnwiredOptions): any {
  return new LayerUnwiredClass(opts);
};

export const LayerUnwired = (L.tileLayer as any).Unwired;
